/* ROOMS · Підписка (sections/rooms-signup.liquid).
   1. Показ картки: таймер, курсор до вкладок, відмова й підписка в localStorage, ярлик до кінця візиту.
   2. Фото змінюються завісою знизу вгору, поки картка відкрита.
   3. Метелик прилітає на логотип і сідає на літеру (маршрути ті самі, що в assets/custom-header.js).
   4. Підказка в порожньому полі друкується по літерах. */
(() => {
  const root = document.querySelector('[data-rooms-signup]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const KEY = 'rooms-signup';
  const TAB_KEY = 'rooms-signup-tab';
  const DAY = 864e5;
  const card = root.querySelector('.rooms-signup__card');
  const tab = root.querySelector('[data-rooms-signup-open]');
  const state = root.dataset.state;
  const design = root.dataset.design === 'true';
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  let isOpen = false;
  let timer = null;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch (e) {
      return {};
    }
  };
  const write = (patch) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch }));
    } catch (e) {}
  };
  const setTabFlag = (on) => {
    try {
      on ? sessionStorage.setItem(TAB_KEY, '1') : sessionStorage.removeItem(TAB_KEY);
    } catch (e) {}
  };
  const tabFlag = () => {
    try {
      return sessionStorage.getItem(TAB_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  // Фото й логотип у прихованій картці ліниві й не вантажаться, доки вона не відкриється;
  // підвантажуємо їх заздалегідь, щойно сторінка спокійно завантажилась.
  const warm = () => card.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
  if (document.readyState === 'complete') setTimeout(warm, 1500);
  else window.addEventListener('load', () => setTimeout(warm, 1500), { once: true });

  /* ---------- 2. Фото ---------- */
  const slides = (() => {
    const list = [...root.querySelectorAll('[data-rooms-signup-slide]')];
    if (list.length < 2 || calm) return { start() {}, stop() {} };
    const every = Math.max(3, Number(root.dataset.interval) || 5) * 1000;
    let i = 0;
    let t = null;
    const next = () => {
      const cur = list[i];
      i = (i + 1) % list.length;
      const nxt = list[i];
      nxt.classList.add('is-enter');
      nxt.addEventListener(
        'animationend',
        () => {
          cur.classList.remove('is-active');
          nxt.classList.remove('is-enter');
          nxt.classList.add('is-active');
        },
        { once: true }
      );
      t = setTimeout(next, every);
    };
    return {
      start() {
        clearTimeout(t);
        t = setTimeout(next, every);
      },
      stop() {
        clearTimeout(t);
      }
    };
  })();

  /* ---------- 3. Метелик ---------- */
  const pet = (() => {
    const el = root.querySelector('[data-rooms-pet]');
    const logo = root.querySelector('[data-rooms-signup-logo]');
    const ok = window.CSS && CSS.supports && CSS.supports('offset-path', 'path("M0 0L1 1")');
    if (!el || !logo || calm || !ok) return { start() {}, stop() {} };

    // маршрути намальовані для логотипа завширшки 100px (як у шапці) і масштабуються під ширину
    const ROUTES_IN = [
      { to: 'S', p: [['M', 158, -46], ['C', 122, -42, 80, -30, 44, -20], ['C', 16, -13, -14, 2, -2, 17], ['C', 8, 30, 48, 33, 72, 25], ['C', 88, 19, 93, 13, 93, -2]] },
      { to: 'S', p: [['M', 50, -62], ['C', 96, -60, 130, -30, 116, -6], ['C', 106, 10, 84, 16, 76, 8], ['C', 72, 4, 93, 12, 93, -2]] },
      { to: 'O', p: [['M', -44, -30], ['C', -10, -34, 40, -32, 96, -18], ['C', 118, -10, 112, 14, 90, 24], ['C', 70, 32, 54, 28, 50, 14], ['C', 50, 8, 50, 2, 50, -3]] },
      { to: 'R', p: [['M', 140, 40], ['C', 120, 10, 100, -24, 60, -26], ['C', 24, -28, -20, -16, -22, 6], ['C', -24, 20, -4, 26, 7, 14], ['C', 10, 8, 8, 2, 7, -2]] }
    ];
    const ROUTES_OUT = {
      S: [['M', 93, -2], ['C', 93, -14, 104, -24, 118, -30], ['C', 136, -38, 152, -48, 168, -62]],
      O: [['M', 50, -3], ['C', 50, -16, 70, -30, 100, -34], ['C', 130, -38, 150, -52, 170, -66]],
      R: [['M', 7, -2], ['C', 7, -16, 30, -30, 60, -30], ['C', 90, -30, 120, -44, 150, -64]]
    };
    const TIMES = { butterfly: { inn: 3500, sit: 5200, out: 1800 }, bird: { inn: 2700, sit: 4200, out: 1400 } };
    const scaled = (path, k) =>
      'path("' + path.map((seg) => seg[0] + seg.slice(1).map((n) => (n * k).toFixed(1)).join(' ')).join(' ') + '")';

    let on = false;
    let busy = false;
    let last = -1;
    let t = null;
    const kind = el.getAttribute('data-rooms-pet');

    function visit() {
      if (!on || busy || document.hidden) return;
      const k = logo.offsetWidth / 100;
      if (!k) return;
      let i;
      do i = Math.floor(Math.random() * ROUTES_IN.length);
      while (i === last && ROUTES_IN.length > 1);
      last = i;
      const inn = ROUTES_IN[i];
      el.style.setProperty('--rooms-pet-size', (15 * k).toFixed(1) + 'px');
      el.style.setProperty('--rooms-pet-in', scaled(inn.p, k));
      el.style.setProperty('--rooms-pet-out', scaled(ROUTES_OUT[inn.to], k));
      const tm = TIMES[kind] || TIMES.butterfly;
      busy = true;
      el.className = 'rooms-pet rooms-pet--signup is-in';
      t = setTimeout(() => {
        el.className = 'rooms-pet rooms-pet--signup is-sit';
        t = setTimeout(() => {
          el.className = 'rooms-pet rooms-pet--signup is-out';
          t = setTimeout(() => {
            el.className = 'rooms-pet rooms-pet--signup';
            busy = false;
            if (on) t = setTimeout(visit, 7000 + Math.random() * 6000);
          }, tm.out);
        }, tm.sit + Math.random() * 1500);
      }, tm.inn);
    }

    logo.addEventListener('mouseenter', visit);
    return {
      start() {
        on = true;
        clearTimeout(t);
        if (!busy) t = setTimeout(visit, 1300);
      },
      stop() {
        on = false;
        clearTimeout(t);
        busy = false;
        el.className = 'rooms-pet rooms-pet--signup';
      }
    };
  })();

  /* ---------- 4. Підказка в полі ---------- */
  const typer = (() => {
    const el = root.querySelector('[data-rooms-signup-type]');
    const input = root.querySelector('.rooms-signup__input');
    if (!el || !input) return { start() {}, stop() {} };
    const field = el.parentNode;
    const out = el.querySelector('.rooms-signup__type-text');
    let lines = [];
    try {
      lines = JSON.parse(el.dataset.lines).map((s) => s.trim()).filter(Boolean);
    } catch (e) {}
    if (!lines.length) return { start() {}, stop() {} };
    field.classList.add('is-typing');
    const sync = () => {
      field.classList.toggle('is-filled', input.value !== '');
      field.classList.toggle('is-focus', document.activeElement === input);
    };
    ['input', 'focus', 'blur'].forEach((ev) => input.addEventListener(ev, sync));
    sync();

    let t = null, li = 0, ci = 0, dir = 1, on = false;
    const tick = () => {
      if (!on) return;
      const line = lines[li];
      ci += dir;
      out.textContent = line.slice(0, ci);
      el.classList.add('is-busy');
      let wait = dir > 0 ? 60 + Math.random() * 70 : 28;
      if (dir > 0 && ci >= line.length) {
        dir = -1;
        wait = 1900;
        el.classList.remove('is-busy');
      } else if (dir < 0 && ci <= 0) {
        dir = 1;
        li = (li + 1) % lines.length;
        wait = 420;
        el.classList.remove('is-busy');
      }
      t = setTimeout(tick, wait);
    };
    return {
      start() {
        if (on) return;
        on = true;
        if (calm) {
          out.textContent = lines[0];
          return;
        }
        li = 0;
        ci = 0;
        dir = 1;
        out.textContent = '';
        t = setTimeout(tick, 1100);
      },
      stop() {
        on = false;
        clearTimeout(t);
      }
    };
  })();

  /* ---------- 1. Показ ---------- */
  const showTab = (on) => {
    if (tab) tab.hidden = !on;
  };

  function open(byUser) {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(timer);
    showTab(false);
    root.classList.add('is-open');
    card.setAttribute('aria-hidden', 'false');
    slides.start();
    pet.start();
    typer.start();
    // фокус переносимо лише коли людина сама відкрила картку: інакше вона заважала б гортати сайт
    if (byUser) {
      const input = card.querySelector('.rooms-signup__input');
      setTimeout(() => (fine && input ? input : card).focus({ preventScroll: true }), 80);
    }
  }

  function close(how) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    card.setAttribute('aria-hidden', 'true');
    slides.stop();
    pet.stop();
    typer.stop();
    if (design) return;
    if (state === 'success') {
      setTabFlag(false);
      return;
    }
    write({ dismissed: Date.now() });
    if (how === 'min') {
      setTabFlag(true);
      setTimeout(() => showTab(true), 500);
    } else {
      setTabFlag(false);
    }
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-rooms-signup-min]')) close('min');
    else if (e.target.closest('[data-rooms-signup-close]')) close('dismiss');
    else if (e.target.closest('[data-rooms-signup-open]')) open(true);
  });
  card.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close('min');
  });

  // Редактор тем: картка відкривається, коли вибирають секцію, і закривається, коли її полишають.
  if (design) {
    document.addEventListener('shopify:section:select', (e) => {
      if (e.detail.sectionId === root.dataset.section) open(false);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (e.detail.sectionId === root.dataset.section) close();
    });
    return;
  }

  // Повернулися після відправки форми. Shopify позначає успіхом усі форми підписки на сторінці,
  // тож дивимося на якір: #rooms-signup-form — відправили картку, інакше форму у футері.
  if ((state === 'success' || state === 'error') && location.hash !== '#rooms-signup-form') {
    if (state === 'success') write({ subscribed: Date.now() });
    return;
  }
  if (state === 'success' || state === 'error') {
    const url = new URL(location.href);
    url.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', url.pathname + url.search);
    if (state === 'success') write({ subscribed: Date.now() });
    open(state === 'error');
    return;
  }

  const saved = read();
  if (saved.subscribed) return;
  if (tabFlag()) {
    showTab(true);
    return;
  }
  const days = Number(root.dataset.days) || 7;
  if (saved.dismissed && Date.now() - saved.dismissed < days * DAY) return;

  // Сама картка виїжджає один раз: далі на сторінках візиту ярлик, наступного разу — через `days` днів.
  const autoOpen = () => {
    write({ dismissed: Date.now() });
    setTabFlag(true);
    open(false);
  };
  timer = setTimeout(autoOpen, (Number(root.dataset.delay) || 15) * 1000);

  if (root.dataset.exit === 'true' && fine) {
    const armed = Date.now() + 4000;
    const onLeave = (e) => {
      if (e.relatedTarget || e.clientY > 0 || Date.now() < armed) return;
      document.removeEventListener('mouseout', onLeave);
      if (!isOpen) autoOpen();
    };
    document.addEventListener('mouseout', onLeave);
  }
})();
